"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dnif = void 0;
const base_model_1 = require("../base-model");
const dnif_schema_1 = require("./dnif.schema");
class Dnif extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return dnif_schema_1.dnifSchema;
    }
}
exports.Dnif = Dnif;
